if (!customElements.get('ingredient-info')) {
  class IngredientInfo extends HTMLElement {
    constructor() {
      super();

      const triggers = document.querySelectorAll('[data-ingredient-card]');
      const close_triggers = document.querySelectorAll('[data-close-modal]');
      const modal = document.getElementById('ingredient-modal');
      const modal_content = document.getElementById('ingredient-modal-content');

      const clickHandler = (e) => {
        const blog_handle = e.currentTarget.dataset.ingredientHandle;

        fetch(`/blogs/${blog_handle}`)
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, 'text/html');

            const mainElement = xmlDoc.querySelector('main');
            if (mainElement) {
              modal_content.innerHTML = mainElement.outerHTML;
              modal.classList.remove('hidden');
              modal.inert = false;
              document.body.style.overflowY = 'hidden';

              // Update the URL with the blog_handle parameter
              const url = new URL(window.location.href);
              url.searchParams.set('blog_handle', blog_handle);
              history.pushState({}, '', url.toString());
            } else {
              console.error('Main element not found in the server response.');
            }
          })
          .catch((err) => console.error(err));
      };

      triggers.forEach((trigger) => {
        if (!trigger.clickHandlerAdded) {
          trigger.addEventListener('click', clickHandler);
          trigger.clickHandlerAdded = true;
        }
      });

      close_triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.closeModal.bind(this));
      });

      document.addEventListener('keydown', this.keydownHandler.bind(this));

      document.addEventListener('DOMContentLoaded', () => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlBlogHandle = urlParams.get('blog_handle');
        if (urlBlogHandle) {
          clickHandler({ currentTarget: { dataset: { ingredientHandle: urlBlogHandle } } });
        }
      });
    }

    closeModal() {
      const modal = document.getElementById('ingredient-modal');
      modal.classList.add('hidden');
      modal.inert = true;
      document.body.style.overflowY = 'auto';

      const url = new URL(window.location.href);
      url.searchParams.delete('blog_handle');
      history.pushState({}, '', url.toString());
    }

    keydownHandler(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  }

  window.IngredientInfo = IngredientInfo;

  customElements.define('ingredient-info', IngredientInfo);
}
